const PrivacyPolicy = () => {
  return (
    <div
      style={{
        margin: '2rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 22,
      }}
    >
      <>
        <style
          dangerouslySetInnerHTML={{
            __html:
              '\n<!--\n /* Font Definitions */\n @font-face\n\t{font-family:Wingdings;\n\tpanose-1:5 0 0 0 0 0 0 0 0 0;}\n@font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:Calibri;\n\tpanose-1:2 15 5 2 2 2 4 3 2 4;}\n@font-face\n\t{font-family:Verdana;\n\tpanose-1:2 11 6 4 3 5 4 4 2 4;}\n /* Style Definitions */\n p.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin:0in;\n\ttext-align:justify;\n\tline-height:15.0pt;\n\tfont-size:11.0pt;\n\tfont-family:"Arial",sans-serif;}\np.MsoHeader, li.MsoHeader, div.MsoHeader\n\t{margin:0in;\n\ttext-align:justify;\n\tline-height:15.0pt;\n\tfont-size:11.0pt;\n\tfont-family:"Arial",sans-serif;}\np.MsoFooter, li.MsoFooter, div.MsoFooter\n\t{margin:0in;\n\ttext-align:justify;\n\tfont-size:9.0pt;\n\tfont-family:"Verdana",sans-serif;}\np.MsoBodyTextIndent, li.MsoBodyTextIndent, div.MsoBodyTextIndent\n\t{mso-style-link:"Body Text Indent Char";\n\tmargin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.25in;\n\ttext-align:justify;\n\tline-height:150%;\n\tfont-size:11.0pt;\n\tfont-family:"Arial",sans-serif;}\np\n\t{margin-right:0in;\n\tmargin-left:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;}\np.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:8.0pt;\n\tmargin-left:.5in;\n\tline-height:107%;\n\tfont-size:11.0pt;\n\tfont-family:"Calibri",sans-serif;}\np.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.5in;\n\tline-height:107%;\n\tfont-size:11.0pt;\n\tfont-family:"Calibri",sans-serif;}\np.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:.5in;\n\tline-height:107%;\n\tfont-size:11.0pt;\n\tfont-family:"Calibri",sans-serif;}\np.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:8.0pt;\n\tmargin-left:.5in;\n\tline-height:107%;\n\tfont-size:11.0pt;\n\tfont-family:"Calibri",sans-serif;}\nspan.BodyTextIndentChar\n\t{mso-style-name:"Body Text Indent Char";\n\tmso-style-link:"Body Text Indent";\n\tfont-family:"Arial",sans-serif;}\n.MsoChpDefault\n\t{font-size:10.0pt;}\n /* Page Definitions */\n @page WordSection1\n\t{size:595.35pt 842.0pt;\n\tmargin:56.7pt 85.05pt 56.7pt 85.05pt;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\n ol\n\t{margin-bottom:0in;}\nul\n\t{margin-bottom:0in;}\n-->\n',
          }}
        />
        <div className='WordSection1'>
          <p
            className='MsoHeader'
            style={{ textAlign: 'center' }}
            align='center'
          >
            <strong>
              <span lang='DE'>Nutzungsbedingungen</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ textAlign: 'center' }}
            align='center'
          >
            <span lang='DE'>&nbsp;</span>
          </p>
          <p className='MsoHeader'>
            <span lang='DE'>
              Diese Nutzungsbedingungen vom [Datum] (nachfolgend
              <strong> Nutzungsbedingungen</strong>) von uns, der CO2OPT GmbH,
              [Anschrift] (nachfolgend <strong>CO2OPT</strong>), regeln
              ergänzend zu unseren Online-Angeboten die Vertragsbeziehung mit
              Ihnen (nachfolgend <strong>Kunde</strong>).
            </span>
          </p>
          <p className='MsoHeader'>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                1.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Vertragsschluss</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                1.1.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              Der Abschluss eines kostenpflichtigen Vertrages mit CO2OPT setzt
              die Erstellung eines Nutzerkontos (Kundenkonto) durch
              Registrierung auf der Webseite [<span>…</span> ] (Webseite)
              voraus.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                1.2.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              Zur Registrierung berechtigt sind nur Unternehmen i.S.d. §&nbsp;14
              BGB. Soweit eine natürliche Person für eine juristische Person die
              Registrierung vornimmt, behält sich CO2OPT vor, einen Nachweis
              über die ordnungsgemäße Bevollmächtigung zu verlangen.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                1.3.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              Der Vertragsschluss kann nur auf unserer Webseite unter Verwendung
              des Kundenkontos erfolgen. Etwaige individuellen Vereinbarungen,
              die nicht unmittelbar über die Webseiten-Maske erfolgen, sind
              schriftlich festzuhalten.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                2.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Leistungsbeschreibung</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                2.1.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              CO2OPT bietet eine Lösung an, um das Reifenmanagement des Kunden
              zu optimieren. Hierfür nutzt CO2OPT vom Kunden über dessen
              Telematik-Anbieter freigegeben Daten und fertigt hieraus
              individuelle Reifen-Empfehlungen sowie monatliche Übersichten und
              Handlungsempfehlungen zur Effizienzsteigerung des Fuhrparks. Zudem
              können weitere Leistungen wie z.B. Routenoptimierung oder
              Fahrverhalten gebucht werden. Die jeweiligen genauen
              Leistungsbeschreibungen ergeben sich aus unseren Online-Angeboten.{' '}
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                2.2.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              Nicht von den Leistungen von CO2OPT umfasst ist die eigene
              Bereitstellung von Telematik-Diensten. Ebenso nicht von der
              Leistung umfasst ist der Verkauf von empfohlenen Reifen.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                3.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Leistungspflichten des Kunden</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoListParagraph'
            style={{
              marginLeft: '45.35pt',
              textAlign: 'justify',
              textIndent: '-27.35pt',
              textAutospace: 'none',
            }}
          >
            <strong>
              <span style={{ fontFamily: '"Arial",sans-serif' }} lang='DE'>
                3.1.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <span
              style={{ fontFamily: '"Arial",sans-serif', lineHeight: 1.5 }}
              lang='DE'
            >
              Der Kunde verpflichtet sich, CO2OPT die für die
              Leistungserbringung erforderlichen Daten zur Verfügung zu stellen,
              insbesondere Kfz-Kennzeichen, Werkstattberichte, Standortdaten
              bzw. Bewegungs- und Fahrzeugdaten des gefahrenen Fahrzeugs,
              fahrzeugspezifisch verwendeter Reifentyp sowie bei optionaler
              Versendung von Fotos Inhalt des Fotos und ggf. dazugehörigem Text.
              Hierfür bestehen für den Kunden zwei Möglichkeiten: Der Kunde kann
              CO2OPT über die REST API die Möglichkeit geben, unmittelbar über
              Schnittstellen &nbsp;Zugang zu den Daten zu erhalten (z.B. über
              Schnittstellen der Telematikanbieter). Alternativ kann der Kunde
              die Daten manuell mit der Funktion CSV-Upload über vordefinierte
              Vorlagen auf der Webseite von CO2OPT eingeben.{' '}
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                3.2.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              Der Kunde sichert zu, dass er alle erforderlichen Daten CO2OPT zur
              Verfügung stellt. CO2OPT prüft die zur Verfügung gestellten Daten
              nicht auf Richtigkeit. Außerdem verpflichtet sich der Kunde dazu,
              nur eigene Daten zur Verfügung zu stellen und keine Daten Dritter.
              Insbesondere garantiert der Kunde, dass die zur Verfügung
              gestellten Daten keine Rechte Dritter verletzen.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                3.3.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <span lang='DE'>
              Der Kunde ist verantwortlich für die Verfügbarkeit des Dienstes
              der Datenanbieter.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                4.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Leistungspflichten von CO2OPT</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '49.65pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              4.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span lang='DE'>
              Falls notwendig anonymisiert CO2OPT in einem ersten Schritt die
              zur Verfügung gestellten Daten für den Kunden als
              Auftragsverarbeiter in einem abgegrenzten Datenraum. Zur
              datenschutzrechtlichen Absicherung der Anonymisierung wird ein
              Auftragsverarbeitungsvertrag zwischen CO2OPT und dem Kunden
              geschlossen. Der Auftragsverarbeitungsvertrag gemäß{' '}
              <strong>Anlage 1</strong> ist Bestandteil dieser
              Nutzungsbedingungen.{' '}
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '49.65pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '49.65pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              4.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span lang='DE'>
              Die anonymisierten Daten verwendet CO2OPT zur Ermittlung von
              wirtschaftlichen Optimierungsmaßnahmen wie in unseren
              Online-Angeboten beschrieben. Die Ergebnisse zum
              Optimierungspotential basieren dabei auf der Grundlage eines
              fiktiven optimalen Fahrzeugführers sowie optimaler Verkehrs- und
              Witterungsbedingungen. Hiervon kann das tatsächliche
              Optimierungspotential abweichen; dieses ist nicht Teil der
              Leistungspflichten von CO2OPT.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '49.65pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '49.65pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              4.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span lang='DE'>
              Die Optimierungsmöglichkeiten, die Entwicklung der Verbesserung
              und das maximal theoretische Einsparpotential werden dem Kunden
              auf der Webseite über das Kundenkonto zur Verfügung gestellt.
              Dabei gewährleistet CO2OPT im Monatsmittel eine 98-prozentige
              Verfügbarkeit der Webseite. Hiervon ausgenommen sind
              Nichtverfügbarkeiten aufgrund höherer Gewalt, technischer
              Störungen von Dritten oder rechtswidriger Angriffe, die entweder
              CO2OPT selbst oder Drittanbieter betreffen.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '49.65pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p className='MsoHeader'>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                5.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Rechteeinräumung</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              5.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span lang='DE'>
              Der Kunde stellt CO2OPT die anonymisierten Daten zur freien
              Verwendung zur Verfügung.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              5.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span lang='DE'>
              CO2OPT räumt dem Kunde ein einfaches, nicht übertragbares, auf die
              Dauer der Vertragsbeziehung limitiertes Nutzungsrecht an der über
              das Kundenkonto bereitgestellten Software ein. Der Kunde ist nicht
              berechtigt, die Software zu bearbeiten.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              5.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span lang='DE'>
              Alle schutzfähigen und nicht schutzfähigen Arbeitsergebnisse,
              insbesondere geistiges Eigentum (im Folgenden "IP" genannt),
              Rechte (einschließlich Urheberrechte, gewerbliche Schutzrechte,
              wie Patente und alle IP-bezogenen Nutzungsrechte) an und im
              Zusammenhang mit Werken oder Derivaten davon, Erfindungen und
              Informationen, einschließlich, aber nicht beschränkt auf,
              Algorithmen, Software, Quellcodes, Objektcodes, Materialien,
              Methoden, Werkzeuge, Know-how, Analysen und Produkte,
              Produkt-Updates und Produkt-Upgrades, sowie alle Rechte an und für
              alle Entwicklungen und alle anderen Arbeitsprodukte, die aus der
              Verwendung der anonymisierten Daten des Kunden durch CO2OPT
              generiert, erstellt und/oder abgeleitet werden (zusammen:
              Arbeitsergebnisse), sind alleiniges Eigentum von CO2OPT. Nur
              CO2OPT hat das Recht, die Arbeitsergebnisse kommerziell zu
              verwerten und anderweitig zu nutzen, einschließlich, aber nicht
              beschränkt auf die Weiterentwicklung aller entwickelten
              Arbeitsergebnisse. Diese Rechte umfassen auch das Recht, die
              Arbeitsergebnisse unterzulizenzieren, zu verarbeiten und
              weiterzuentwickeln.{' '}
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                6.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Zahlungspflicht</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <span lang='DE'>
              Preise, Zahlungsfristen und Zahlungsmöglichkeiten ergeben sich aus
              unseren Online-Angeboten.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                7.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Haftung</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '0in',
              marginLeft: '45.35pt',
              textAlign: 'justify',
              textIndent: '-27.35pt',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                color: 'black',
              }}
              lang='DE'
            >
              7.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span
              style={{
                // fontSize: '11.0pt',
                lineHeight: 1.2,
                fontFamily: '"Arial",sans-serif',
              }}
              lang='DE'
            >
              Ansprüche des Kunden auf Schadensersatz sind ausgeschlossen.
              Hiervon ausgenommen sind Schadensersatzansprüche des Kunden aus
              der Verletzung des Lebens, des Körpers, der Gesundheit oder aus
              der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten)
              sowie die Haftung für sonstige Schäden, die auf einer
              vorsätzlichen oder grob fahrlässigen Pflichtverletzung von CO2OPT,
              ihrer gesetzlichen Vertreter oder Erfüllungsgehilfen beruhen.
              Wesentliche Vertragspflichten sind solche, deren Erfüllung die
              ordnungsgemäße Vertragsdurchführung erst ermöglicht und auf deren
              Einhaltung der Vertragspartner vertraut und auch vertrauen darf.
            </span>
          </p>
          <p
            style={{
              margin: '0in',
              textAlign: 'justify',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                color: 'black',
              }}
              lang='DE'
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '0in',
              marginLeft: '45.35pt',
              textAlign: 'justify',
              textIndent: '-27.35pt',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                color: 'black',
              }}
              lang='DE'
            >
              7.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span
              style={{
                // fontSize: '11.0pt',
                lineHeight: 1.2,
                fontFamily: '"Arial",sans-serif',
                // color: 'black',
              }}
              lang='DE'
            >
              Bei der Verletzung wesentlicher Vertragspflichten haftet CO2OPT
              nur auf den vertragstypischen, vorhersehbaren Schaden, wenn dieser
              einfach fahrlässig verursacht wurde, es sei denn, es handelt sich
              um Schadensersatzansprüche des Kunden aus einer Verletzung des
              Lebens, des Körpers oder der Gesundheit.
            </span>
          </p>
          <p
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '0in',
              marginLeft: '.25in',
              textAlign: 'justify',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                // color: 'black',
              }}
              lang='DE'
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '0in',
              marginLeft: '45.35pt',
              textAlign: 'justify',
              textIndent: '-27.35pt',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                color: 'black',
              }}
              lang='DE'
            >
              7.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                // color: 'black',
              }}
              lang='DE'
            >
              Die Einschränkungen von 7.1. und 7.2. gelten auch zugunsten der
              gesetzlichen Vertreter und Erfüllungsgehilfen von CO2OPT, wenn
              Ansprüche direkt gegen diese geltend gemacht werden.
            </span>
          </p>
          <p
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '0in',
              marginLeft: '.25in',
              textAlign: 'justify',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                // color: 'black',
              }}
              lang='DE'
            >
              &nbsp;
            </span>
          </p>
          <p
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '0in',
              marginLeft: '45.35pt',
              textAlign: 'justify',
              textIndent: '-27.35pt',
              lineHeight: '115%',
              verticalAlign: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                color: 'black',
              }}
              lang='DE'
            >
              7.4.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;{' '}
              </span>
            </span>
            <span
              style={{
                fontSize: '11.0pt',
                lineHeight: '115%',
                fontFamily: '"Arial",sans-serif',
                // color: 'black',
              }}
              lang='DE'
            >
              Die sich aus 7.1. und 7.2. ergebenden Haftungsbeschränkungen
              gelten nicht, soweit CO2OPT einen Mangel arglistig verschwiegen
              oder eine Garantie für die Beschaffenheit einer Sache übernommen
              hat. Das gleiche gilt, soweit CO2OPT und der Kunde eine
              Vereinbarung über die Beschaffenheit der Sache getroffen haben.
              Die Vorschriften des Produkthaftungsgesetzes bleiben unberührt.
            </span>
          </p>
          <p className='MsoHeader'>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                8.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Laufzeit &amp; Vertragsbeendigung</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '42.55pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              8.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            <span lang='DE'>
              Die Vertragslaufzeit beträgt, wenn nicht anders in unseren
              Online-Angeboten angegeben, 12 Monate und verlängert sich jeweils
              um 12 Monate, wenn nicht drei Monate vor Ablauf der
              Vertragslaufzeit gekündigt wurde.
            </span>
          </p>
          <p className='MsoHeader'>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '42.55pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              8.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            <span lang='DE'>
              Den Parteien steht das Recht zur fristlosen außerordentlichen
              Kündigung aus wichtigem Grund zu. Ein solcher Grund liegt
              insbesondere vor, wenn der Kunde wiederholt gegen diese
              Nutzungsbedingungen verstößt.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '42.55pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '42.55pt', textIndent: '-27.35pt' }}
          >
            <span lang='DE'>
              8.3.
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            <span lang='DE'>
              Das Recht zur außerordentlichen Kündigung aus wichtigem Grund
              kraft Gesetzes bleibt von Ziff. 8 unberührt.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                9.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Verschwiegenheit</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span lang='DE'>
              9.1
              <span style={{ font: '7.0pt "Times New Roman"' }}>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            <span lang='DE'>
              Alle Informationen aus der vertraglichen Beziehung zwischen den
              Parteien sind vertraulich. Die Parteien unterlassen es, diese
              Informationen an Dritte weiterzugeben.
            </span>
            <span style={{ color: 'black' }} lang='DE'>
              Die Parteien werden sämtliche ihm im Zusammenhang mit der
              Durchführung der Tätigkeit zur Kenntnis gelangenden Betriebs- und
              Geschäftsgeheimnisse – auch und soweit sie sich auf Dritte
              beziehen – vertraulich behandeln und Dritten gegenüber geheim
              halten. Das Unternehmen wird insbesondere die Informationen zu den
              vorgestellten Fachkräften keinen Dritten zugänglich machen.
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              &nbsp;
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              9.2&nbsp;&nbsp;&nbsp; Betriebsgeheimnisse sind auch
              Computerprogramme, technisches Know-how, Betriebsmethoden,
              Sicherheitsmaßnahmen, Kundendaten, (im Folgenden Informationen
              genannt) sowie insbesondere auch Stammdaten (Kundenstammdaten) und
              sonstige personenbezogene Daten.{' '}
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              &nbsp;
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              9.3&nbsp;&nbsp;&nbsp; Die Pflicht zur Verschwiegenheit sowie die
              Pflicht zur vertraulichen Behandlung von Informationen, Unterlagen
              und Dateien gilt auch gegenüber Gesellschaftern und Mitarbeitern,
              soweit diese nicht im betrieblichen Interesse in die
              Zusammenarbeit mit eingebunden und zur Bearbeitung der sich darauf
              beziehenden Angelegenheiten befugt sind. Die Weitergabe der
              Informationen an Dritte bedarf der vorherigen schriftlichen
              Genehmigung.
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              &nbsp;
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              9.4&nbsp;&nbsp;&nbsp; Die Verpflichtung zur vertraulichen
              Behandlung gilt nicht für Ideen, Konzeptionen, Know-how und
              Techniken sowie für Informationen, die bereits vor Projektbeginn
              bzw. Vertragsschluss (es gilt der frühere Zeitpunkt) bekannt waren
              oder außerhalb der Zusammenarbeit nach Maßgabe dieses
              Vertragswerkes ohne Verstoß gegen diese Vereinbarung bekannt
              werden.
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              &nbsp;
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              9.5&nbsp;&nbsp;&nbsp; Eine Partei ist von der Verpflichtung zur
              vertraulichen Behandlung befreit, wenn sie die erhaltenden
              Informationen auf Grund gesetzlicher Bestimmungen oder Verfügungen
              staatlicher Organe offenlegen muss, jedoch nicht bevor der
              Sachverhalt der anderen Partei schriftlich angezeigt wurde. Legt
              die andere Partei entsprechende Rechtsmittel gegen die Offenbarung
              der Informationen ein, so sind beide Parteien weiterhin an die
              vertragliche Geheimhaltungsverpflichtung gebunden.
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              &nbsp;
            </span>
          </p>
          <p
            className='MsoBodyTextIndent'
            style={{
              marginLeft: '42.55pt',
              textIndent: '-27.0pt',
              lineHeight: '15.0pt',
            }}
          >
            <span style={{ color: 'black' }} lang='DE'>
              9.6&nbsp;&nbsp;&nbsp; Diese Vertraulichkeitsverpflichtungen
              bestehen auch nach einer Beendigung des Vertrages fort.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                10.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Abtretung</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '49.65pt', textIndent: '-28.7pt' }}
          >
            <span lang='DE'>
              10.1.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
            </span>
            <span lang='DE'>
              Jede Übertragung von Rechten und Pflichten, in Teilen oder als
              Ganzes seitens des Kunden bedarf der vorherigen schriftlichen
              Zustimmung von CO2OPT.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '49.65pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '49.65pt', textIndent: '-28.7pt' }}
          >
            <span lang='DE'>
              10.2.
              <span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
            </span>
            <span lang='DE'>
              CO2OPT ist berechtigt, die aus dem Vertrag entstehenden Rechte und
              Pflichten ganz oder teilweise auf ein anderes Unternehmen zu
              übertragen. CO2OPT wird den Kunden über eine solche Übertragung
              informieren und für den Fall, dass der Kunde mit der Übertragung
              nicht einverstanden ist, hat der Kunde eine Frist von zwei (2)
              Wochen, um den Vertrag zu kündigen, oder den Vertrag zum regulären
              Kündigungstermin kündigen.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <span lang='DE'>&nbsp;</span>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '21.3pt', textIndent: '-21.3pt' }}
          >
            <strong>
              <span lang='DE'>
                11.
                <span style={{ font: '7.0pt "Times New Roman"' }}>
                  &nbsp;&nbsp;{' '}
                </span>
              </span>
            </strong>
            <strong>
              <span lang='DE'>Schlussbestimmungen</span>
            </strong>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '21.3pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                11.1.<span style={{ font: '7.0pt "Times New Roman"' }}> </span>
              </span>
            </strong>
            <span lang='DE'>
              Änderungen und Ergänzungen des Vertrages und der
              Nutzungsbedingungen – einschließlich dieser Klausel – bedürfen der
              Schriftform.
            </span>
          </p>
          <p className='MsoHeader' style={{ marginLeft: '45.35pt' }}>
            <strong>
              <span lang='DE'>&nbsp;</span>
            </strong>
          </p>
          <p
            className='MsoHeader'
            style={{ marginLeft: '45.35pt', textIndent: '-27.35pt' }}
          >
            <strong>
              <span lang='DE'>
                11.2.<span style={{ font: '7.0pt "Times New Roman"' }}> </span>
              </span>
            </strong>
            <span lang='DE'>
              Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss
              des UN-Kaufrechts (CISG). Ausschließlicher Gerichtsstand ist
              Hamburg, Deutschland.{' '}
            </span>
          </p>
        </div>
      </>
    </div>
  );
};

export default PrivacyPolicy;
